export type FeatureFlagValue = boolean | string | number | Array<string>;

export type FeatureFlag = {
    key: string;
    defaultValue: FeatureFlagValue;
};

export const FeatureFlags: Record<string, FeatureFlag> = {
    opsHealthChecksMarkHealthy: {
        key: 'ops-health-checks-mark-healthy',
        defaultValue: false,
    },
    isChatEnabled: {
        key: 'Access-RepairerFrontend-Chat',
        defaultValue: false,
    },
    isMicrosoftClarityEnabled: {
        key: 'Release-MicrosoftClarity-Enabled',
        defaultValue: false,
    },
    isClaimNumberValidationWithDrpRelationshipsEnabled: {
        key: 'Release-ClaimNumberValidation-UseDrpRelationships',
        defaultValue: false,
    },
    mfesWithQueryClientCachePersistence: {
        key: 'Release-RepairerFrontend-PersistCache',
        defaultValue: [],
    },
    isReturnsFlowEnabled: {
        key: 'Access-MSOReturns-CompleteFlow',
        defaultValue: false,
    },
    isSuggestedPartsEnabled: {
        key: 'Release-SuggestedParts',
        defaultValue: false,
    },
    isUserPilotEnabled: {
        key: 'Release-RepairerFrontend-UserPilot',
        defaultValue: false,
    },
    isPreferredVendorMaintenanceEnabled: {
        key: 'Access-RepairerFrontend-PreferredVendorMaintenance',
        defaultValue: false,
    },
    isVendorViewEnabled: {
        key: 'Release-PreferredVendorManagement-VendorView',
        defaultValue: false,
    },
    isPreferredVendorCloneShopEnabled: {
        key: 'Release-PreferredVendorManagement-CloneShop',
        defaultValue: false,
    },
    isExportOnConfirmEnabled: {
        key: 'Release-RepairerFrontend-ExportOnConfirm',
        defaultValue: false,
    },
    isOrderReturnRequestsFeatureAvailable: {
        key: 'Access-MSOReturns-DisplayReturnRequests',
        defaultValue: false,
    },
    isReturnSummaryChartsEnabled: {
        key: 'Access-MSOReturns-SummaryCharts',
        defaultValue: false,
    },
    isPriceMatchPackagesEnabled: {
        key: 'Release-PartSelection-PriceMatchPackages',
        defaultValue: false,
    },
    isPartSelectionSortQuotesEnabled: {
        key: 'Release-PartSelection-SortQuotes',
        defaultValue: false,
    },
    isMinimalOrderViewEnabled: {
        key: 'Release-JobOrderSummary-UseMinimalOrderView',
        defaultValue: false,
    },
    isOrderlyUIThemeEnabled: {
        key: 'Release-RepairerFrontend-OrderlyUITheme',
        defaultValue: false,
    },
    isMultiLocationAccessEnabled: {
        key: 'Release-RepairerFrontend-MultiLocationAccess',
        defaultValue: false,
    },
    isDisplayWarningsForAftermarketPartsEnabled: {
        key: 'Access-RepairerFrontend-DisplayWarningsForAftermarketParts',
        defaultValue: false,
    },
    isShowReturnsDateInitiatedColumnEnabled: {
        key: 'Release-MSOReturns-ShowReturnsDateInitiatedColumn',
        defaultValue: false,
    },
    isAdjustListPriceEnabledForSelectionLock: {
        key: 'Release-SelectionLockRules-AdjustListPrice',
        defaultValue: false,
    },
    isExcludedPartEnabled: {
        key: 'Release-PartSection-EnableExcludePart',
        defaultValue: false,
    },
    isGetJobPartsStaleTimeEnabled: {
        key: 'Release-PartsPage-GetJobPartsStaleTime',
        defaultValue: true,
    },
    isSaveRequestMoreQuotesEnabled: {
        key: 'Release-PartSelection-SaveRequestMoreQuotes',
        defaultValue: false,
    },
    isSaveAlteredPackageCustomSelectionsEnabled: {
        key: 'Release-PartSelection-SaveAlteredPackageCustomSelections',
        defaultValue: false,
    },
    isComplianceViewEnabled: {
        key: 'Access-Compliance-DisplayComplianceView',
        defaultValue: true,
    },
    isCreditsEnabled: {
        key: 'Access-RepairerFrontend-Credits',
        defaultValue: false,
    },
    isHideGrossProfitApplicable: {
        key: 'Access-RepairerInvoice-HideGrossProfit',
        defaultValue: false,
    },
    isAutoAgentOrderingEnabled: {
        key: 'Access-AutoAgent-AutoOrdering',
        defaultValue: false,
    },
    isAutoAgentAllowFinalAutoOrderingOnlyIfOn: {
        key: 'Access-AutoAgent-AllowFinalAutoOrderingOnlyIfOn',
        defaultValue: false,
    },
    isQuoteWindow30minDefaultEnabled: {
        key: 'Access-QuoteWindow-30minDefault',
        defaultValue: false,
    },
    isCreditsMatchedUnmatchedFilterEnabled: {
        key: 'Release-Credits-MatchedUnmatchedFilter',
        defaultValue: false,
    },
    isNotificationsEnabled: {
        key: 'Release-Notifications-ProcessForRepairer',
        defaultValue: false,
    },
    isCreditsViewCreditCartEnabled: {
        key: 'Release-Credits-ViewCreditCart',
        defaultValue: false,
    },
    isCreditsVendorFilterEnabled: {
        key: 'Release-Credits-VendorFilter',
        defaultValue: false,
    },
    isCreditsNewIndicatorEnabled: {
        key: 'Release-Credits-NewIndicator',
        defaultValue: false,
    },
} as const;
